import { Dropdown, Select } from "@gw/web-basic-components";
import React, { useEffect, useMemo, useState } from "react";
import ColorPicker from "./color-picker";

const BORDER = [
  {
    name: "上",
    type: "solid",
    color: "#cccccc",
  },
  {
    name: "右",
    type: "solid",
    color: "#cccccc",
  },
  {
    name: "下",
    type: "solid",
    color: "#cccccc",
  },
  {
    name: "左",
    type: "solid",
    color: "#cccccc",
  },
];

const BORDER_MAP = new Map();
BORDER_MAP.set("左", "borderLeft");
BORDER_MAP.set("右", "borderRight");
BORDER_MAP.set("上", "borderTop");
BORDER_MAP.set("下", "borderBottom");

export interface BorderProps {
  borderTop?: string;
  borderRight?: string;
  borderBottom?: string;
  borderLeft?: string;
  border?: string;
}

export interface BorderPickerProps {
  value?: BorderProps;
  onChange?: (color: BorderProps) => void;
}

const getBorderCopy = (border: BorderProps) => {
  if (border.border) {
    return {
      borderTop: border.border,
      borderRight: border.border,
      borderBottom: border.border,
      borderLeft: border.border,
    };
  }
  return { ...border };
};

/**
 * 边框选择器
 * @returns
 */
const BorderPicker = (props: BorderPickerProps) => {
  const [borderValue, setBorderValue] = useState(
    props.value !== undefined
      ? props.value
      : {
          border: "1px solid #cccccc",
        }
  );

  /**
   * 值
   */
  const value = useMemo(() => {
    const v = props.value !== undefined ? props.value : borderValue;
    if (!v) {
      return BORDER;
    }
    if (v.border) {
      // 复合属性
      return BORDER.map((item) => {
        const border = v.border.split(" ");
        return {
          ...item,
          type: border[1],
          color: border[2],
        };
      });
    } else {
      return BORDER.map((item) => {
        const currentBorder = v[BORDER_MAP.get(item.name)];
        const border = currentBorder.split(" ");
        return {
          ...item,
          type: border[1],
          color: border[2],
        };
      });
    }
  }, [props.value, borderValue]);

  /**
   * 值改变
   * @param v
   */
  const handleOnChange = (v: BorderProps) => {
    if (props.value === undefined) {
      setBorderValue(v);
    }
    // 总是触发 onChange 回调
    props.onChange?.(v);
  };

  /**
   * 下拉框渲染
   */
  const dropdownRender = () => {
    return (
      <div className="wbuc-flex wbuc-flex-col wbuc-gap-2 wbuc-rounded-[0.5rem] wbuc-bg-[#FFFFFF] wbuc-p-5 wbuc-shadow">
        {value.map((item) => {
          return (
            <div
              className="wbuc-flex wbuc-flex-shrink-0 wbuc-items-center wbuc-gap-2"
              key={item.name}
            >
              <span>{item.name}</span>
              <Select
                size="small"
                className="!wbuc-w-28 wbuc-flex-shrink-0"
                value={item.type}
                onChange={(e) => {
                  const v = getBorderCopy(borderValue);
                  v[BORDER_MAP.get(item.name)] = `1px ${e} ${item.color}`;
                  handleOnChange(v);
                }}
              >
                <Select.Option value="none">无边框</Select.Option>
                <Select.Option value="solid">实线</Select.Option>
                <Select.Option value="dashed‌">虚线</Select.Option>
              </Select>
              <ColorPicker
                value={item.color}
                noneValue="#cccccc"
                onChange={(e) => {
                  const v = getBorderCopy(borderValue);
                  v[BORDER_MAP.get(item.name)] = `1px ${item.type} ${e}`;
                  handleOnChange(v);
                }}
              />
            </div>
          );
        })}
      </div>
    );
  };

  useEffect(() => {
    if (props.value !== undefined) {
      setBorderValue(props.value);
    }
  }, [props.value]);

  return (
    <Dropdown dropdownRender={dropdownRender} trigger={["click"]}>
      <Select open={false} />
    </Dropdown>
  );
};

export default BorderPicker;
